import GlobalVariable from '../global/global-variable'

// 查询应用信息
const searchAppApi = GlobalVariable.BASE_PATH + "/rest/app/search";

// 查询组织结构
const findOrgApi = GlobalVariable.BASE_PATH + "/rest/app/findOrg";

// 查询登录账户下的项目
const findLoginProjectApi = GlobalVariable.BASE_PATH + "/rest/account/project/findByAccountId";

// 删除项目
const deleteProjectApi = GlobalVariable.BASE_PATH + "/rest/project/delete";

// 删除区域
const deleteAreaApi = GlobalVariable.BASE_PATH + "/rest/area/delete";

// 删除地图
const deleteMapApi = GlobalVariable.BASE_PATH + "/rest/map/delete";

// 修改应用
const updateAppApi = GlobalVariable.BASE_PATH + "/rest/app/update";

// 添加项目
const addProjectApi = GlobalVariable.BASE_PATH + "/rest/project/add";

// 查询项目
const findProjectApi = GlobalVariable.BASE_PATH + "/rest/project/findByProjectId";

// 修改应用
const updateProjectApi = GlobalVariable.BASE_PATH + "/rest/project/update";

// 添加大区域
const addAreaApi = GlobalVariable.BASE_PATH + "/rest/area/add";

// 修改大区域
const updateAreaApi = GlobalVariable.BASE_PATH + "/rest/area/update";

// 添加小区域
const addMapApi = GlobalVariable.BASE_PATH + "/rest/map/add";

// 修改小区域
const updateMapApi = GlobalVariable.BASE_PATH + "/rest/map/update";

// 根据项目查询地图
const findMapByProjectIdApi = GlobalVariable.BASE_PATH + "/rest/map/finByProjectId";

// 查询区域
const findAreaByIdApi = GlobalVariable.BASE_PATH + "/rest/area/finByAreaId";

// 查询地图
const findMapByIdApi = GlobalVariable.BASE_PATH + "/rest/map/finByMapId";

// 上传文件
const uploadFileApi = GlobalVariable.BASE_PATH + "/rest/file/uploadOneImage";

// 查询隧道库
const findTunnelStoreApi = GlobalVariable.BASE_PATH + "/images/tunnel_store";

export default {
    searchAppApi,
    findOrgApi,
    findLoginProjectApi,
    deleteProjectApi,
    deleteAreaApi,
    deleteMapApi,
    updateAppApi,
    addProjectApi,
    findProjectApi,
    findMapByProjectIdApi,
    updateProjectApi,
    addAreaApi,
    updateAreaApi,
    addMapApi,
    updateMapApi,
    findAreaByIdApi,
    findMapByIdApi,
    uploadFileApi,
    findTunnelStoreApi
}



// WEBPACK FOOTER //
// ./src/request/api-org.js